import React, { useState } from 'react'
import styles from '../stylesheets/Header.module.scss'
import Fade from 'react-reveal/Fade'
import BackgroundImage from 'gatsby-background-image'
import { FaAngleDoubleRight } from 'react-icons/fa';

const Header = (props) => {
  const [state, setState] = useState({
    isHovered: false
  })

  const handleMouseEnter = () => {
    setState({ isHovered: true })
  }

  const handleMouseLeave = () => {
    setState({ isHovered: false })
  }

  const date = new Date()
  const hours = date.getHours()
  let timeOfDay

  if (hours < 12 && hours > 6) {
    timeOfDay = 'morning'
  } else if (hours > 12 && hours < 18) {
    timeOfDay = 'afternoon'
  } else {
    timeOfDay = 'evening'
  }

  return (
      <BackgroundImage
        className={styles.masthead}
        id="home"
        ref={props.sectionRefs[0]}
        fluid={props.fluid}
      >
        <div className={styles.content}>
          <div className={styles.greeting}>
            <Fade top>
              <p>Good {timeOfDay}. My name is <strong className={styles.name}>Arne</strong>.</p>
              <p>I'm a front-end developer.</p>
            </Fade>
          </div>
          <Fade bottom>
            <a
              className={styles.button}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              href="#about"
            >
              <span>Show me more &nbsp;&nbsp;&nbsp;</span><FaAngleDoubleRight
                className={styles.icon + " " + (state.isHovered && styles.hovered)}
              />
            </a>
          </Fade>
        </div>
      </BackgroundImage>
  )
}

export default Header
